<template>
  <div class="w-full">
    <slot v-if="state === 'loading'" name="loading"><AtomIconAppLoader class="w-12 h-12" /></slot>
    <slot v-if="state === 'error'" name="error" />
    <slot v-if="state === 'ready'" v-bind="page" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { setupSiteConfig } from '~/composables/craft'
import { usePageStore } from '~/store/page'

interface Props {
  site?: string
  uri: string
}

const { uri, site: propSite = undefined } = defineProps<Props>()

const emit = defineEmits(['error'])

const state = ref('loading')
const page = ref(null)
const pageStore = usePageStore()

// Fallback site configuration
let site = propSite
if (!site) {
  const { site: fallbackSite } = setupSiteConfig()
  site = fallbackSite
}

onMounted(async () => {
  try {
    page.value = await pageStore.fetchUri({ site, uri })
    state.value = page.value ? 'ready' : 'error'
  } catch (error) {
    emit('error', { uri, site, error })
    state.value = 'error'
  }
})
</script>
